export default __webpack_public_path__ + "static/media/aetr-field.4c240a6a.svg";